import * as React from 'react'
import './style.less'
import {Button} from 'telstra-ui/components/button/Button'
import {Pictograms} from 'telstra-ui/components/svg/Pictograms'
import {useNavigate} from 'react-router-dom'

const NoMarkerData = () => {
  const navigate = useNavigate()
  return (
    <div className="tc-np-map-marker-no-data-container">
      <div className="tc-np-inner-container">
        <div className="tc-np-description-container ">
          <summary className="heading16 summary">No data available</summary>
          <div className="description">
            We currently provide network performance reporting for Business IP products (BIP),
            Telstra Internet Direct (TID) and Integrated Operations Management (IOM) as a beta for
            some customers. If you have any of these services and they are not displaying, please
            let us know.
          </div>
        </div>
        <Pictograms name="picto-empty" className="picto-empty" />
      </div>

      <div className="button-container">
        <Button variant="secondary" size="xSmall" onClick={() => navigate('/app/support/feedback')}>
          Submit feedback
        </Button>
      </div>
    </div>
  )
}

export {NoMarkerData}
